import { Wallet, Users } from "lucide-react";
import { Money } from "./SaudiRiyal";

const COLORS = ["bg-rose-500", "bg-indigo-500", "bg-amber-500", "bg-emerald-500", "bg-sky-500", "bg-fuchsia-500", "bg-slate-500"];

export const CostByCategory = ({ items = [] }) => !items.length ? null : (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-2" data-testid="company-cost-categories">
    <p className="text-sm font-semibold text-slate-700">المصروفات حسب التصنيف</p>
    <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-slate-100">
      {items.map((c, i) => <div key={c.category} className={COLORS[i % COLORS.length]} style={{ width: `${c.pct}%` }} />)}
    </div>
    <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
      {items.map((c, i) => (
        <div key={c.category} className="flex items-center justify-between gap-2 text-sm" data-testid={`cost-cat-${c.category}`}>
          <span className="flex items-center gap-1.5 text-slate-700"><span className={`h-2.5 w-2.5 rounded-full ${COLORS[i % COLORS.length]}`} /> {c.category}</span>
          <span className="text-slate-600"><Money value={c.amount} /> <span className="text-[11px] text-slate-400">({c.pct}%)</span></span>
        </div>
      ))}
    </div>
  </div>
);

export const CostBoxes = ({ cost }) => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-testid="company-cost-boxes">
    <div className="rounded-2xl border border-rose-200 bg-rose-50/60 p-4" data-testid="company-cost-total">
      <div className="flex items-center gap-2 text-sm text-rose-700"><Wallet className="h-4 w-4" /> إجمالي المصروفات (مبلغ آخر سداد)</div>
      <div className="mt-1 text-2xl font-bold text-rose-700"><Money value={cost.total} /></div>
      <p className="mt-1 text-[11px] text-slate-500">مجموع مبالغ آخر سداد لكل السجلات والاشتراكات (سنوي)</p>
    </div>
    <div className="rounded-2xl border border-indigo-200 bg-indigo-50/60 p-4" data-testid="company-cost-per-rider">
      <div className="flex items-center gap-2 text-sm text-indigo-700"><Users className="h-4 w-4" /> تكلفة المندوب الثابتة</div>
      <div className="mt-1 flex flex-wrap items-baseline gap-x-4 gap-y-1">
        <span className="text-2xl font-bold text-indigo-700" data-testid="company-cost-month"><Money value={cost.per_rider_month} /> <span className="text-xs font-normal">/ شهرياً</span></span>
        <span className="text-lg font-bold text-indigo-600" data-testid="company-cost-year"><Money value={cost.per_rider_year} /> <span className="text-xs font-normal">/ سنوياً</span></span>
      </div>
      <p className="mt-1 text-[11px] text-slate-500">الإجمالي ÷ <b data-testid="company-cost-residents">{cost.residents}</b> مقيم — يتغيّر تلقائياً مع دخول وخروج المقيمين</p>
    </div>
  </div>
);
